import React from 'react';
import Link from '@mui/material/Link';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useHistory } from 'react-router';
import { providerPatientRoute } from '@uplift/constants';
import { ProviderFinancePeriodItem } from '@uplift/api';


const useStyles = makeStyles()({
  link: {
    cursor: 'pointer',
    fontSize: '16px'
  }
});

export type ClientCellProps = {
  value?: ProviderFinancePeriodItem['patient'];
  disableLink?: boolean;
};


export const ClientCell: React.VFC<ClientCellProps> = ({ value, disableLink }) => {
  const history = useHistory();
  const { classes } = useStyles();

  if (value instanceof Object) {
    const name = `${value.firstName} ${value.lastName}`;

    if (disableLink) {
      return <Typography variant="body2" color="textPrimary">{name}</Typography>;
    }

    return (
      <Link className={classes.link} component="span" onClick={() => history?.push(providerPatientRoute.createLink({ patientId: value.id }))}>
        {name}
      </Link>
    );
  }

  return null;
};
